export enum ActionType {
    OPEN_MESSAGE="OPEN_SELF_ORDER_MESSAGE"
}

interface IOpenMessage {
    type: ActionType.OPEN_MESSAGE,
    open: boolean
}

export type Action = IOpenMessage;